type SequenceValidationResult = true | string;

export function toSequenceNumberOrNull(value: unknown): number | null {
  if (value == null || value === "") return null;
  const rawValue =
    typeof value === "object" && value !== null && "value" in value ? (value as { value?: unknown }).value : value;
  if (rawValue == null || rawValue === "") return null;
  const result = typeof rawValue === "number" ? rawValue : Number(rawValue);
  return Number.isFinite(result) ? result : null;
}

export function validateBreakdownSequenceValue(params: {
  value: unknown;
  previousValues: unknown[];
  maxCount: number | null;
}): SequenceValidationResult {
  const { value, previousValues, maxCount } = params;
  if (!value) return true;

  const selectedValue = toSequenceNumberOrNull(value);
  if (selectedValue == null) return "Invalid selection";

  const previousValue = getPreviousSequenceValue(previousValues);
  if (previousValue == null) {
    return selectedValue === 1 || "First selection must be 1";
  }

  if (selectedValue === previousValue) return true;
  if (selectedValue === previousValue + 1 && (maxCount == null || selectedValue <= maxCount)) return true;

  return "Select sequentially (same value or next value only)";
}

export function isBreakdownSequenceValid(values: unknown[], maxCount: number | null): boolean {
  return values.every(
    (value, index) =>
      validateBreakdownSequenceValue({
        value,
        previousValues: values.slice(0, index),
        maxCount,
      }) === true,
  );
}

function getPreviousSequenceValue(values: unknown[]): number | null {
  for (let i = values.length - 1; i >= 0; i--) {
    const previousValue = toSequenceNumberOrNull(values[i]);
    if (previousValue != null) return previousValue;
  }
  return null;
}
